<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon left :color="estado ? 'success' : 'warning'">
          {{ estado ? 'mdi-check-circle' : 'mdi-alert-circle' }}
        </v-icon>
        {{ estado ? 'Validar Cuenta Internacional' : 'Desvalidar Cuenta Internacional' }}
      </v-card-title>

      <v-card-text>
        <v-alert
          :type="estado ? 'success' : 'warning'"
          prominent
          text
          class="mb-4"
        >
          {{ mensajeAccion }}
        </v-alert>

        <div>
          <v-row dense>
            <v-col cols="12">
              <div class="text-subtitle-2 grey--text">Banco</div>
              <div class="text-body-1 font-weight-medium">
                {{ editedItem.banco || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="text-subtitle-2 grey--text">Beneficiario</div>
              <div class="text-body-1 font-weight-medium">
                {{ editedItem.nombre_beneficiario || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="6" class="mt-2">
              <div class="text-subtitle-2 grey--text">Cuenta</div>
              <div class="text-body-1">
                {{ editedItem.cuenta || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="6" class="mt-2">
              <div class="text-subtitle-2 grey--text">Moneda</div>
              <div class="text-body-1">
                {{ editedItem.moneda || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="6" class="mt-2">
              <div class="text-subtitle-2 grey--text">SWIFT</div>
              <div class="text-body-1">
                {{ editedItem.swift || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="6" class="mt-2">
              <div class="text-subtitle-2 grey--text">IBAN</div>
              <div class="text-body-1">
                {{ editedItem.isbn || 'N/A' }}
              </div>
            </v-col>

            <v-col cols="12" class="mt-2" v-if="editedItem.clave_int">
              <div class="text-subtitle-2 grey--text">Clave Interbancaria</div>
              <div class="text-body-1">
                {{ editedItem.clave_int }}
              </div>
            </v-col>
          </v-row>
        </div>

        <br>

        <div class="text-body-1">
          ¿Está seguro de realizar esta acción?
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          text
          color="green"
          @click="cancelar"
          :disabled="loading"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="red"
          :loading="loading"
          :disabled="loading"
          @click="confirmar"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DialogoValidacionCuentaInternacional',
  
  data() {
    return {
      dialog: false,
      estado: null,
      loading: false,
      editedItem: {
        id_proveedor_cuenta_internacional: null,
        id_proveedor: null,
        banco: null,
        nombre_beneficiario: null,
        clave_int: null,
        cuenta: null,
        swift: null,
        isbn: null,
        id_moneda: null,
        moneda: null,
        fecha_actualizacion: null,
        usuario_actualizo: null,
        fecha_validacion: null,
        usuario_valido: null
      },
      defaultEditedItem: {
        id_proveedor_cuenta_internacional: null,
        id_proveedor: null,
        banco: null,
        nombre_beneficiario: null,
        clave_int: null,
        cuenta: null,
        swift: null,
        isbn: null,
        id_moneda: null,
        moneda: null,
        fecha_actualizacion: null,
        usuario_actualizo: null,
        fecha_validacion: null,
        usuario_valido: null
      }
    }
  },

  computed: {
    mensajeAccion() {
      if (this.estado) {
        return 'Está a punto de VALIDAR esta cuenta internacional. Una vez validada, la cuenta será marcada como verificada en el sistema.';
      } else {
        return 'Está a punto de DESVALIDAR esta cuenta internacional. Esta acción removerá la marca de validación de la cuenta.';
      }
    }
  },

  methods: {
    open(item, estado) {
      this.editedItem = Object.assign({}, item);
      this.estado = estado;
      this.dialog = true;
    },

    cancelar() {
      this.dialog = false;
      this.loading = false;
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.estado = null;
    },

    async confirmar() {
      if(this.estado == null) return;
      this.loading = true;
      
      axios
      .post('/Proveedores/CambiarValidacionProveedorCuentaInternacional', {
        id_proveedor_cuenta_internacional: this.editedItem.id_proveedor_cuenta_internacional,
        validar: this.estado
      })
      .then(() => {
        this.cancelar();
        this.$emit('change', null)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>